import {fade} from '@material-ui/core/styles/colorManipulator';
import {createMuiTheme} from '@material-ui/core/styles';

export const colors = {
  black: '#000',
  greyBlack: '#222',
  greyDark: '#323232',
  greyMid: '#656565',

  navyDark: '#0d3471',
  navyLight: '#00529b',

  blueDrab: '#22a1c4',
  blueSky: '#009cdf',
  bluePale: '#80d3f5',

  orangeDark: '#f46e01',
  orangeLight: '#f0ad4e',
  orangeFanta: '#f99300',

  greyLight: '#ddd',
  greyLighter: '#e9e9e9',
  greyLightest: '#eeeeee',
  white: '#fff',

  brandPrimary: '#0275d8',
  brandSuccess: '#5cb85c',
  brandInfo: '#5bc0de',
  brandDanger: '#d9534f',
  highlightMain: '#fdffcc',
};

export const typography = {
  baseSpacingUnit: '24px',
  baseSize: '16px',

  // Major Third
  alphaSize: '2.441rem',
  betaSize: '1.953rem',
  gammaSize: '1.563rem',
  deltaSize: '1.25rem',
  microSize: '1rem',
  milliSize: '0.75rem',

  fontWeightBase: '400',
  fontWeightBold: '700',
};

export default createMuiTheme({
  typography: {
    fontFamily: 'Roboto, sans-serif',
    useNextVariants: true,
  },
  palette: {
    primary: {
      light: colors.navyLight,
      main: colors.blueDrab,
      dark: colors.navyDark,
      text: colors.greyDark,
      contrastText: colors.white,
    },
    secondary: {
      light: colors.orangeLight,
      main: colors.orangeFanta,
      dark: colors.orangeDark,
      text: fade(colors.greyDark, 0.54),
      contrastText: colors.white,
    },
    highlight: {
      main: colors.highlightMain,
      light: '#7d7d67',
    },
    common: {
      white: colors.white,
      black: colors.black,
    },
    success: {
      main: colors.brandSuccess,
    },
    info: {
      main: colors.brandInfo,
    },
    danger: {
      main: colors.brandDanger,
    },
  },
  overrides: {
    MuiDialog: {
      root: {
        zIndex: '1500 !important',
      },
    },
    MuiAutocomplete: {
      popper: {
        zIndex: '1500 !important',
      },
    },
  },
});
